import * as types from './mutation-types'

const mutations = {
  [types.SET_SEARCHOBJ](state, searchObj) {
    state.searchObj = searchObj
  },
  [types.SET_NEWADDRESS](state, obj) {
    state.newAddress = obj
  },
  [types.SET_AREACODE](state, arr) {
    state.areaCode = arr
  },
  [types.SET_USERINFO](state, obj) {
    state.userInfo = obj
  },
  [types.SET_CLASSIFY](state, obj) {
    state.classify = obj
  },
  [types.SET_LOCATION](state, obj) {
    state.city_location = obj
  },
  [types.SET_AVATAR](state, img) {
    state.userInfo.headImage = img
  },
  [types.SET_NAME](state, account) {
    state.userInfo.account = account
  },
  [types.SET_CURRENTPRO](state, obj) {
    state.currentPro = obj
  },
  [types.SET_SHOPPINGCART](state, obj) {
    state.shoppingCart = obj
  },
  [types.SET_CARTNUMBER](state, num) {
    state.cartNumber = num
  },
  [types.SET_NOTICEID](state, num) {
    state.noticeId = num
  },
  [types.SET_COLLECTDATA](state, obj) {
    state.collectData = obj
  },
  [types.SET_componentContent](state, obj) {
    state.componentContent = obj
  },
  [types.SET_componentContentB2c](state, obj) {
    state.componentContentB2c = obj
  },
  [types.SET_shopsData](state,obj){
    state.shopsData = obj
  },
  [types.SET_platform](state, arr) {
    state.platform = arr
  },
  resetVuex(state) {
    state.searchObj = {}
    state.newAddress = {}
    state.areaCode = []
    state.currentPro = {}
    state.userInfo = {
      name: '',
      headImage: ''
    }
    state.city_location = {label:'隆阳区',value:'BASE'}
    state.shoppingCart = {}
    state.cartNumber = ''
    state.evaluateOrders = {}
    state.noticeId = {}
    state.collectData = {}
    state.shopsData = {}
    state.platform = "b2b"
  },
  selectMenu(state, val) {
    state.currentMenu = val
  },
  selectAticle(state, val) {
    state.articleList = val
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js